module.exports = __webpack_public_path__ + "static/media/Tickets-Square.53d586ec.jpg";